<template>

<div class="dropdown">

  <button class="dropbtn" v-html="title"/>

  <div
    class="dropdown-content"
    :class="{ 'opposite-align': reverseAlignment }">

    <div
      v-for="(item, index) in items"
      :key="`${id}-${index}`"
      :href="item.link"
      @click="click(item.clickValue)"
      v-html="item.text"/>

  </div>

</div>

</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    id: String,
    title: String,
    backwards: String,
    click: Function,
    items: Array
  },
  computed: {
    reverseAlignment: function() {
      return this.backwards == 'true'
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  display: inline-block;

  .dropbtn {
    font-size: 18px;
    font-family: 'Poppins-ExtraBold';
    font-weight: bold;
    background-color: inherit;
    border: none;
    text-transform: uppercase;
  }

  .opposite-align {
    right: 0;
  }

  .dropdown-content {
    display: none;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    position: absolute;
    background-color: #ffffff;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;

    div {
      display: block;
      text-align: left;
      text-decoration: none;
      padding: 12px 16px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &:hover .dropdown-content {
    display: block;
  }
}
</style>
